import { AllureMochaReporter } from "./AllureMochaReporter.js";

export default AllureMochaReporter;
